import { computed, ref } from '@vue/composition-api'
import store from '@/shared/store'
import i18n from '@hw-core/libs/i18n'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@hw-ui/components/toastification/ToastificationContent.vue'

export default function useAreaList() {
  const refShifts = ref([])
  const toast = useToast()

  const selectedAccount = computed(() => store.state.appAccount.selectedAccount)
  const currentUser = computed(() => store.state.appAuth.authUser)
  const loggedUser = currentUser.value

  /**
   * fetch shifts
   * @returns shifts[]
   */
  function fetchShifts(callback) {
    const accountId = loggedUser.role === 'customer' ? selectedAccount.value.value.id : null
    const onlyAreas = loggedUser.role === 'customer' && loggedUser.areas ? loggedUser.areas : null
    store.dispatch('appActionCenter/fetchShifts', { accountId, onlyAreas, callback })
  }

  async function sendConfirmationEmail({
    to, message, subject,
  }) {
    await store.dispatch('appActionCenter/sendVerificationEmail', {
      to,
      message,
      subject,
    })
  }

  async function sendEmailWithCC({to, cc, subject, message}) {
    await store.dispatch('appActionCenter/sendEmailWithCC', {
      to,
      cc,
      subject,
      message,
    })
  }

  async function createConfirmationTicket({
    requester = null, groupId, message, subject, collaborators,
  }) {
    const response = await store.dispatch('appActionCenter/createZendeskTicket', {
      requester,
      groupId,
      message,
      subject,
      collaborators,
    })
    return response.data
  }

  async function updateConfirmationTicket({
    requester = null, ticketId, message, collaborators,
  }) {
    const response = await store.dispatch('appActionCenter/updateZendeskTicket', {
      requester,
      ticketId,
      message,
      collaborators,
    })
    return response.data
  }

  function fetchShiftPikapalkka(callback) {
    const accountId = selectedAccount.value.value.id
    const onlyAreas = loggedUser.role === 'customer' && loggedUser.areas ? loggedUser.areas : null
    const isisAllAccount = false
    store.dispatch('appActionCenter/fetchShiftPikapalkka', {
      accountId, onlyAreas, isisAllAccount, callback,
    })
  }

  function fetchShiftPast(callback) {
    const accountId = selectedAccount.value.value.id
    const onlyAreas = loggedUser.role === 'customer' && loggedUser.areas ? loggedUser.areas : null
    store.dispatch('appActionCenter/fetchShiftPast', { accountId, onlyAreas })
      .then(shifts => {
        callback(shifts)
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: i18n.t('error'),
            text: 'Virhe vuorojen hakemisessa',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  async function updateShift({ id, updates }) {
    await store.dispatch('appActionCenter/updateShift', { id, updates })
  }

  async function sendConfirmNotificationSMS({
    mobile, message,
  }) {
    await store.dispatch('appActionCenter/sendSMS', {
      mobile,
      message,
    }).then(() => {
      toast({
        component: ToastificationContent,
        props: {
          title: i18n.t('success'),
          text: 'Tekstiviesti lähetetty',
          icon: 'CheckIcon',
          variant: 'success',
        },
      })
    }).catch(() => {
      toast({
        component: ToastificationContent,
        props: {
          title: i18n.t('error'),
          text: 'Virhe tekstiviestin lähettämisessä',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    })
  }

  function getCancelShiftEmail(shift) {
    const { user, area } = shift
    const message = `<p style="text-transform:capitalize">Hei ${user.firstName},</p>
    <p>Your shift from ${shift.start.toLocaleString('fi')} to ${shift.end.toLocaleString('fi')} at <span style="text-transform:capitalize">${area.name}</span> has been canceled as the customer stated you did not complete your shift</p>
    <p>Please contact us if you disagree with the customer's statement</p>
    <p>Best regards,</p>
    <p>Hoiwa-timi</p>`
    return message
  }

  const createClientRequest = async clientRequest => {
    const accountId = selectedAccount.value.value.id
    const response = await store.dispatch('appActionCenter/createClientRequest', { ...clientRequest, accountId })
    return response
  }

  return {
    refShifts,
    fetchShifts,
    sendConfirmationEmail,
    createConfirmationTicket,
    updateConfirmationTicket,
    fetchShiftPikapalkka,
    fetchShiftPast,
    sendConfirmNotificationSMS,
    updateShift,
    getCancelShiftEmail,
    createClientRequest,
    sendEmailWithCC,
  }
}
